/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Password_ConfirmInputs */

const cs_portal_password_confirm = /** @type {(inputs: Portal_Password_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrzení hesla`)
};

const en_portal_password_confirm = /** @type {(inputs: Portal_Password_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm password`)
};

/**
* | output |
* | --- |
* | "Confirm password" |
*
* @param {Portal_Password_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portal_password_confirm = /** @type {((inputs?: Portal_Password_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Password_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_password_confirm(inputs)
	return cs_portal_password_confirm(inputs)
});